<template>
  <span :class="elementClass">
    <span style="display: inline-table" ref="field" @click="activate" :class="{ activate: this.isActive }">
      <slot></slot>
    </span>
    <div
      ref="child"
      v-click-outside="onClickOutside"
      :class="dropdownClass"
      :style="{
        position: 'fixed',
        top: y + 'px',
        left: fromRight ? 'auto' : x + 'px',
        right: fromRight ? x + 'px' : 'auto',
        'z-index': 100,
        display: 'table',
      }"
    >
      <slot name="content"></slot>
    </div>
  </span>
</template>

<script>
import { menuClass } from "../prefix";
// import Textfield from "./Textfield";
import vClickOutside from "v-click-outside";

export default {
  props: {
    fromRight: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    elementClass() {
      return menuClass;
    },
    dropdownClass() {
      let data = {};
      data[`${menuClass}-dropdown`] = true;
      data["active"] = this.isActive;
      return data;
    },
    displayValue() {
      if (!this.internalValue) return "";
      return this.internalValue.toLocaleDateString("en-GB");
    },
  },
  data() {
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      isActive: false,
      isBlockBlur: false,
      internalValue: "",
    };
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  methods: {
    ready() {
      let data = this.$refs.field.getBoundingClientRect();
      this.x = this.fromRight ? document.body.clientWidth - (data.x + data.width) : data.x;
      this.y = data.y + data.height;
      this.height = data.height;
    },
    activate() {
      setTimeout(() => {
        if (this.isBlockBlur) {
          this.isBlockBlur = false;
        } else {
          if (this.isActive) {
            this.isActive = false;
          } else {
            this.ready();
            this.isActive = true;
          }
        }
      }, 100);
    },
    onClickOutside() {
      if (this.isActive) {
        this.isActive = false;
        this.isBlockBlur = true;
      } else {
        this.isBlockBlur = false;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.ready();
      window.addEventListener("resize", () => {
        this.ready();
      });
      window.addEventListener(
        "scroll",
        () => {
          this.onClickOutside();
        },
        true
      );
    });
  },
  beforeDestroy() {
    document.body.removeChild(this.$refs.child);
  },
};
</script>

<style lang="scss">
@import "../scss/import.scss";
$element: $prefix + "-menu";

#{$element} {
  display: inline-table;
  .activate {
    .inner {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
}
#{$element}-dropdown {
  visibility: hidden;
  opacity: 0;
  @include transform(translateY(-30px) scaleY(0));
  transition: all 0.4s $animation-standard-curve-timing-function, opacity 0.12s $animation-sharp-curve-timing-function;
  @include transform-origin((50% 0));
  height: auto;
  min-width: 200px;
  padding: 8px 0;
  background: white;
  box-shadow: 0 8px 16px 0px rgba(10, 14, 29, 0.04), 0px 8px 64px 0px rgba(10, 14, 29, 0.08);
  &.active {
    transition: all 0.2s $animation-deceleration-curve-timing-function, opacity 0.3s $animation-sharp-curve-timing-function;
    visibility: visible;
    opacity: 1;
    @include transform(translateY(0px) scaleY(1));
  }
}
</style>
